import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useSelector } from 'react-redux';
import qs from 'qs';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { Link, withRouter } from 'react-router-dom';
import ClassNames from 'classnames';
import _get from 'lodash/get';
import { createStructuredSelector } from 'reselect';
import _isEmpty from 'lodash/isEmpty';
import RegionBanner from 'components/RegionBanner';
import {
  makeSelectClientDetails,
  makeSelectRegion,
} from 'containers/Main/selectors';

const styles = theme => ({
  buttonRoot: {
    color: 'white',
    maxWidth: '100%',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  avatar: {
    height: 52,
    width: 52,
    marginTop: 20,
  },
  downIcon: {
    color: theme.palette.primary.secondary,
  },
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: 138,
  },
  authRoot: {
    height: 160,
  },
  withBanner: {
    height: 200,
  },
  joinBtn: {
    width: 197,
    height: 40,
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: 2,
    ...theme.typography.button,
  },
  accountText: {
    ...theme.typography.overline,
    marginTop: 10,
    marginBottom: 5,
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
  },
  account: {
    marginTop: 10,
  },
  linksItem: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    margin: '0 7.5px',
    cursor: 'pointe',
    ...theme.typography.overline,
  },
  logout: {
    position: 'absolute',
    top: 14,
    right: 21,
    color: theme.palette.text.disabled,
    ...theme.typography.overline,
  },
  withRegion: {
    top: 50,
  },
  links: {
    marginBottom: 5,
  },
});
const stateSelector = createStructuredSelector({
  clientDetails: makeSelectClientDetails(),
  region: makeSelectRegion(),
});

function MobileAccountInfo(props) {
  const {
    profile,
    logout,
    classes,
    isAuthenticated,
    redirect: doRedirect,
  } = props;

  const { redirect } = qs.parse(window.location.search.slice(1));
  const currentPathname = window.location.pathname;
  let goTo;
  if (redirect && redirect !== '/login' && redirect !== '/signup')
    goTo = redirect;
  else if (currentPathname !== '/login' && currentPathname !== '/signup')
    goTo = currentPathname;
  const { clientDetails, region } = useSelector(stateSelector);
  const hasMultipleLanding =
    _get(clientDetails, 'landingLinksCollection.items', []).length > 1;
  const hasClient = !_isEmpty(_get(clientDetails, 'shortName'));
  const showRegionBanner =
    hasClient && (!_isEmpty(region) || hasMultipleLanding);
  if (!isAuthenticated) {
    return (
      <div className={classes.root}>
        {showRegionBanner && <RegionBanner />}
        <ButtonBase
          className={classes.joinBtn}
          onClick={() =>
            doRedirect(`/signup${goTo ? `?redirect=${goTo}` : ''}`)
          }
        >
          JOIN NOW
        </ButtonBase>
        <span className={classes.accountText}>
          Have an account?{' '}
          <Link
            to={`/login${goTo ? `?redirect=${goTo}` : ''}`}
            onClick={() => doRedirect('/login')}
          >
            Log in here
          </Link>
        </span>
      </div>
    );
  }
  const { avatarUrl, displayName, firstName = '', email } = profile;
  const name = (displayName && displayName.split(' ')[0]) || `${firstName}`;

  const userName = name.length > 6 ? `${name.slice(0, 6)}...` : name;

  return (
    <div
      className={ClassNames(classes.root, classes.authRoot, {
        [classes.withBanner]: showRegionBanner,
      })}
    >
      {showRegionBanner && <RegionBanner />}

      <ButtonBase
        onClick={() => logout()}
        className={ClassNames(
          classes.logout,
          showRegionBanner ? classes.withRegion : '',
        )}
      >
        Log out
      </ButtonBase>
      {avatarUrl ? (
        <Avatar alt={userName} src={avatarUrl} className={classes.avatar} />
      ) : (
        <AccountCircle className={classes.avatar} />
      )}
      <Typography
        variant="body2"
        color="textPrimary"
        className={classes.account}
      >
        {' '}
        {userName}
      </Typography>
      <Typography variant="overline" color="textPrimary">
        {' '}
        {email}
      </Typography>
      <div className={classes.links}>
        <Link
          to="/account"
          onClick={() => doRedirect('/account')}
          className={classes.linksItem}
        >
          My Account
        </Link>
        <Link
          to="/favorites"
          onClick={() => doRedirect('/favorites')}
          className={classes.linksItem}
        >
          My Favorites
        </Link>
      </div>
    </div>
  );
}
MobileAccountInfo.propTypes = {
  classes: PropTypes.object,
  profile: PropTypes.object,
  logout: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  redirect: PropTypes.func,
};

export default compose(
  withStyles(styles),
  withRouter,
)(MobileAccountInfo);
